export default "__VITE_ASSET__CJfGUbLP__"